import {
  animate,
  group,
  query,
  sequence,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const leftColAnimation = [
  trigger('leftColAnimation', [
    transition('void => primary', [
      style({ opacity: 0 }),
      query(
        '.header-container',
        style({
          opacity: 0,
          width: '33.33%',
          maxWidth: '32rem',
        })
      ),
      query(
        '.footer-wrapper',
        style({
          width: '33.33%',
          transform: 'translateY(8rem)',
          maxWidth: '32rem',
        }),
        { optional: true }
      ),
      query('.overlay', style({ width: '100%' }), {
        optional: true,
      }),
      query('form > *', style({ opacity: 0 }), {
        optional: true,
      }),

      sequence([
        group(
          [
            animate('400ms ease', style({ opacity: 1 })),
            query(
              '.header-container',
              animate('400ms ease', style({ opacity: 1 }))
            ),
            query('form > *', animate('400ms ease', style({ opacity: 1 })), {
              optional: true,
            }),
            query(
              '.footer-wrapper',
              animate('400ms ease', style({ transform: 'translateY(0)' })),
              { optional: true }
            ),
          ],
          { delay: 200 }
        ),
      ]),
    ]),
    transition('void => secondary', [
      style({ opacity: 0 }),
      animate('0.4s ease', style({ opacity: 1 })),
    ]),
  ]),
];
